export const LOCALHOST = "127.0.0.1";
export const LOCALHOST_HOSTNAME = `localhost`;
export var HTTP_METHOD = /* @__PURE__ */ ((HTTP_METHOD2) => {
  HTTP_METHOD2["HEAD"] = "HEAD";
  HTTP_METHOD2["POST"] = "POST";
  HTTP_METHOD2["GET"] = "GET";
  HTTP_METHOD2["PUT"] = "PUT";
  HTTP_METHOD2["PATCH"] = "PATCH";
  HTTP_METHOD2["DELETE"] = "DELETE";
  HTTP_METHOD2["OPTIONS"] = "OPTIONS";
  return HTTP_METHOD2;
})(HTTP_METHOD || {});
export var HTTP_PROTOCOL = /* @__PURE__ */ ((HTTP_PROTOCOL2) => {
  HTTP_PROTOCOL2["HTTPS"] = "https";
  HTTP_PROTOCOL2["HTTP"] = "http";
  return HTTP_PROTOCOL2;
})(HTTP_PROTOCOL || {});
export var NON_HTTP_PROTOCOL = /* @__PURE__ */ ((NON_HTTP_PROTOCOL2) => {
  NON_HTTP_PROTOCOL2["SMS"] = "sms";
  NON_HTTP_PROTOCOL2["LIGHTNING"] = "lightning";
  return NON_HTTP_PROTOCOL2;
})(NON_HTTP_PROTOCOL || {});
export var WEBSOCKET_PROTOCOL = /* @__PURE__ */ ((WEBSOCKET_PROTOCOL2) => {
  WEBSOCKET_PROTOCOL2["WS"] = "ws";
  WEBSOCKET_PROTOCOL2["WSS"] = "wss";
  return WEBSOCKET_PROTOCOL2;
})(WEBSOCKET_PROTOCOL || {});
export var HTTP_HEADER = /* @__PURE__ */ ((HTTP_HEADER2) => {
  HTTP_HEADER2["ENV"] = "x-env";
  HTTP_HEADER2["ACCOUNT_TOKEN"] = "x-account-token";
  HTTP_HEADER2["ORIGIN"] = "origin";
  HTTP_HEADER2["AUTHORIZATION"] = "authorization";
  HTTP_HEADER2["CONTENT_TYPE"] = "content-type";
  HTTP_HEADER2["CONTENT_LENGTH"] = "content-length";
  HTTP_HEADER2["CONTENT_ENCODING"] = "content-encoding";
  HTTP_HEADER2["ACCEPT"] = "accept";
  HTTP_HEADER2["ACCEPT_LANGUAGE"] = "accept-language";
  HTTP_HEADER2["PAYPAL_REQUEST_ID"] = "paypal-request-id";
  HTTP_HEADER2["PAYPAL_AUTH_ASSERTION"] = "paypal-auth-assertion";
  HTTP_HEADER2["PAYPAL_CLIENT_METADATA_ID"] = "paypal-client-metadata-id";
  HTTP_HEADER2["PAYPAL_PARTNER_ATTRIBUTION_ID"] = "paypal-partner-attribution-id";
  HTTP_HEADER2["PAYPAL_DEBUG_ID"] = "paypal-debug-id";
  HTTP_HEADER2["HOST"] = "host";
  HTTP_HEADER2["LINK"] = "link";
  HTTP_HEADER2["SHOPIFY_ACCESS_TOKEN"] = "x-shopify-access-token";
  HTTP_HEADER2["SHOPIFY_STOREFRONT_ACCESS_TOKEN"] = "x-shopify-storefront-access-token";
  HTTP_HEADER2["SHOPIFY_HMAX_SHA256"] = "x-shopify-hmac-sha256";
  HTTP_HEADER2["SHOPIFY_API_CALL_LIMIT"] = "x-shopify-shop-api-call-limit";
  HTTP_HEADER2["SHOPIFY_SHOP_DOMAIN"] = "x-shopify-shop-domain";
  HTTP_HEADER2["SHOPIFY_WEBHOOK_ID"] = "x-shopify-webhook-id";
  HTTP_HEADER2["WOO_WEBHOOK_SOURCE"] = "x-wc-webhook-source";
  HTTP_HEADER2["WOO_WEBHOOK_SIGNATURE"] = "x-wc-webhook-signature";
  HTTP_HEADER2["FORWARDED_PROTOCOL"] = "x-forwarded-proto";
  HTTP_HEADER2["FORWARDED_HOST"] = "x-forwarded-host";
  HTTP_HEADER2["TWILIO_SIGNATURE"] = "x-twilio-signature";
  HTTP_HEADER2["FORWARDED_IP"] = "x-forwarded-ip";
  HTTP_HEADER2["FORWARDED_FOR"] = "x-forwarded-for";
  HTTP_HEADER2["REAL_IP"] = "x-real-ip";
  HTTP_HEADER2["DIGITAL_OCEAN_CONNECTING_IP"] = "do-connecting-ip";
  HTTP_HEADER2["USER_AGENT"] = "user-agent";
  HTTP_HEADER2["ONETEXT_CONTEXT_ID"] = "x-onetext-context-id";
  HTTP_HEADER2["SLACK_SIGNATURE"] = "x-slack-signature";
  HTTP_HEADER2["SLACK_TIMESTAMP"] = "x-slack-request-timestamp";
  HTTP_HEADER2["SLACK_RETRY"] = "x-slack-retry-num";
  HTTP_HEADER2["STRIPE_ACCOUNT_ID"] = "stripe-account";
  HTTP_HEADER2["STRIPE_WEBHOOK_SIGNATURE"] = "stripe-signature";
  HTTP_HEADER2["ACCESS_CONTROL_ALLOW_ORIGIN"] = "access-control-allow-origin";
  HTTP_HEADER2["ACCESS_CONTROL_ALLOW_METHODS"] = "access-control-allow-methods";
  HTTP_HEADER2["ACCESS_CONTROL_ALLOW_HEADERS"] = "access-control-allow-headers";
  HTTP_HEADER2["ACCESS_CONTROL_EXPOSE_HEADERS"] = "access-control-expose-headers";
  HTTP_HEADER2["ACCESS_CONTROL_REQUEST_METHOD"] = "access-control-request-method";
  HTTP_HEADER2["ACCESS_CONTROL_REQUEST_HEADERS"] = "access-control-request-headers";
  HTTP_HEADER2["TELNYX_SIGNATURE"] = "telnyx-signature-ed25519";
  HTTP_HEADER2["TELNYX_TIMESTAMP"] = "telnyx-timestamp";
  HTTP_HEADER2["LOCATION"] = "location";
  HTTP_HEADER2["RETRY_AFTER"] = "retry-after";
  HTTP_HEADER2["OPENAI_ORGANIZATION"] = "openai-organization";
  HTTP_HEADER2["CONTENT_DISPOSITION"] = "content-disposition";
  HTTP_HEADER2["DATADOG_API_KEY"] = "dd-api-key";
  HTTP_HEADER2["API_KEY"] = "x-api-key";
  HTTP_HEADER2["API_CLIENT"] = "x-api-client";
  HTTP_HEADER2["GUID"] = "x-guid";
  HTTP_HEADER2["TEST_IP"] = "x-test-ip";
  HTTP_HEADER2["INFOBIP_WEBHOOK_SIGNATURE"] = "x-hub-signature";
  HTTP_HEADER2["KLAVIYO_CSRF_TOKEN"] = "x-csrftoken";
  HTTP_HEADER2["COOKIE"] = "cookie";
  HTTP_HEADER2["REFERER"] = "referer";
  HTTP_HEADER2["REFERRER_POLICY"] = "referrer-policy";
  HTTP_HEADER2["IDEMPOTENCY_ID"] = "x-idempotency-id";
  HTTP_HEADER2["ALLOW_RETRY"] = "x-allow-retry";
  HTTP_HEADER2["ALLOW_ALERT"] = "x-allow-alert";
  HTTP_HEADER2["ANTHROPIC_VERSION"] = "anthropic-version";
  HTTP_HEADER2["GITHUB_API_HEADER"] = "x-github-api-version";
  HTTP_HEADER2["REVISION"] = "revision";
  HTTP_HEADER2["ATTENTIVE_WEBHOOK_SIGNATURE"] = "x-attentive-hmac-sha256";
  HTTP_HEADER2["POSTSCRIPT_SIGNATURE"] = "postscript-signature";
  HTTP_HEADER2["PAGE_URL"] = "x-page-url";
  HTTP_HEADER2["BING_API_HEADER"] = "Ocp-Apim-Subscription-Key";
  return HTTP_HEADER2;
})(HTTP_HEADER || {});
export const SAFE_HTTP_HEADERS_TO_LOG = /* @__PURE__ */ new Set([
  "x-env" /* ENV */,
  "x-account-token" /* ACCOUNT_TOKEN */,
  "paypal-request-id" /* PAYPAL_REQUEST_ID */,
  "paypal-auth-assertion" /* PAYPAL_AUTH_ASSERTION */,
  "paypal-client-metadata-id" /* PAYPAL_CLIENT_METADATA_ID */,
  "paypal-partner-attribution-id" /* PAYPAL_PARTNER_ATTRIBUTION_ID */,
  "paypal-debug-id" /* PAYPAL_DEBUG_ID */,
  "host" /* HOST */,
  "link" /* LINK */,
  "x-shopify-shop-api-call-limit" /* SHOPIFY_API_CALL_LIMIT */,
  "x-shopify-shop-domain" /* SHOPIFY_SHOP_DOMAIN */,
  "x-shopify-webhook-id" /* SHOPIFY_WEBHOOK_ID */,
  "x-forwarded-proto" /* FORWARDED_PROTOCOL */,
  "x-forwarded-host" /* FORWARDED_HOST */,
  "x-twilio-signature" /* TWILIO_SIGNATURE */,
  "x-forwarded-ip" /* FORWARDED_IP */,
  "x-forwarded-for" /* FORWARDED_FOR */,
  "x-real-ip" /* REAL_IP */,
  "do-connecting-ip" /* DIGITAL_OCEAN_CONNECTING_IP */,
  "user-agent" /* USER_AGENT */,
  "x-onetext-context-id" /* ONETEXT_CONTEXT_ID */,
  "stripe-account" /* STRIPE_ACCOUNT_ID */,
  "location" /* LOCATION */,
  "retry-after" /* RETRY_AFTER */,
  "openai-organization" /* OPENAI_ORGANIZATION */,
  "content-disposition" /* CONTENT_DISPOSITION */,
  "dd-api-key" /* DATADOG_API_KEY */,
  "x-api-client" /* API_CLIENT */,
  "x-page-url" /* PAGE_URL */
]);
export var HTTP_STATUS = /* @__PURE__ */ ((HTTP_STATUS2) => {
  HTTP_STATUS2[HTTP_STATUS2["OK"] = 200] = "OK";
  HTTP_STATUS2[HTTP_STATUS2["CREATED"] = 201] = "CREATED";
  HTTP_STATUS2[HTTP_STATUS2["ACCEPTED"] = 202] = "ACCEPTED";
  HTTP_STATUS2[HTTP_STATUS2["REQUEST_ERROR"] = 400] = "REQUEST_ERROR";
  HTTP_STATUS2[HTTP_STATUS2["REQUEST_UNAUTHORIZED"] = 401] = "REQUEST_UNAUTHORIZED";
  HTTP_STATUS2[HTTP_STATUS2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HTTP_STATUS2[HTTP_STATUS2["REQUEST_DENIED"] = 403] = "REQUEST_DENIED";
  HTTP_STATUS2[HTTP_STATUS2["REQUEST_NOT_FOUND"] = 404] = "REQUEST_NOT_FOUND";
  HTTP_STATUS2[HTTP_STATUS2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HTTP_STATUS2[HTTP_STATUS2["REQUEST_CONFLICT"] = 409] = "REQUEST_CONFLICT";
  HTTP_STATUS2[HTTP_STATUS2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HTTP_STATUS2[HTTP_STATUS2["REQUEST_TOO_MANY"] = 429] = "REQUEST_TOO_MANY";
  HTTP_STATUS2[HTTP_STATUS2["SERVER_ERROR"] = 500] = "SERVER_ERROR";
  HTTP_STATUS2[HTTP_STATUS2["SERVER_UNAVAILABLE"] = 503] = "SERVER_UNAVAILABLE";
  return HTTP_STATUS2;
})(HTTP_STATUS || {});
export var QUERY_PARAM = /* @__PURE__ */ ((QUERY_PARAM2) => {
  QUERY_PARAM2["ENV"] = "env";
  QUERY_PARAM2["CHECKOUT_TOKEN"] = "checkoutToken";
  QUERY_PARAM2["AUTH_TOKEN"] = "authToken";
  QUERY_PARAM2["CHECKOUT_ERROR"] = "checkoutError";
  QUERY_PARAM2["DEVICE_ID"] = "deviceID";
  QUERY_PARAM2["DEBUG"] = "debug";
  QUERY_PARAM2["ACCOUNT_TOKEN"] = "onetext-account-token";
  QUERY_PARAM2["HOST_ACCOUNT_TOKEN"] = "onetext-host-account-token";
  QUERY_PARAM2["URL_TOKEN"] = "token";
  QUERY_PARAM2["URL_TOKEN_SHORT"] = "t";
  QUERY_PARAM2["FIRST_TIME_LOGIN"] = "firstTime";
  QUERY_PARAM2["CONTEXT_ID"] = "contextID";
  QUERY_PARAM2["TIMESTAMP"] = "timestamp";
  QUERY_PARAM2["ONETEXT_PREVIEW"] = "onetext-preview";
  QUERY_PARAM2["ONETEXT_EDITOR"] = "onetext-editor";
  QUERY_PARAM2["POPUP_ID"] = "popup-id";
  QUERY_PARAM2["FLOW_INSTANCE_GROUP_TOKEN"] = "flow-instance-group-token";
  QUERY_PARAM2["KLAVIYO_IDENTIFIER"] = "nb_klid";
  QUERY_PARAM2["CONCIERGE_PREVIEW"] = "ot-concierge-preview";
  return QUERY_PARAM2;
})(QUERY_PARAM || {});
export var HTTP_CONTENT_TYPE = /* @__PURE__ */ ((HTTP_CONTENT_TYPE2) => {
  HTTP_CONTENT_TYPE2["JSON"] = "application/json";
  HTTP_CONTENT_TYPE2["FORM"] = "application/x-www-form-urlencoded";
  HTTP_CONTENT_TYPE2["GRAPHQL"] = "application/graphql";
  HTTP_CONTENT_TYPE2["XML"] = "text/xml";
  HTTP_CONTENT_TYPE2["HTML"] = "text/html";
  HTTP_CONTENT_TYPE2["BINARY"] = "application/octet-stream";
  return HTTP_CONTENT_TYPE2;
})(HTTP_CONTENT_TYPE || {});
export var HTTP_CONTENT_ENCODING = /* @__PURE__ */ ((HTTP_CONTENT_ENCODING2) => {
  HTTP_CONTENT_ENCODING2["GZIP"] = "gzip";
  return HTTP_CONTENT_ENCODING2;
})(HTTP_CONTENT_ENCODING || {});
export var HTTP_AUTHORIZATION_TYPE = /* @__PURE__ */ ((HTTP_AUTHORIZATION_TYPE2) => {
  HTTP_AUTHORIZATION_TYPE2["BASIC"] = "basic";
  HTTP_AUTHORIZATION_TYPE2["BEARER"] = "bearer";
  return HTTP_AUTHORIZATION_TYPE2;
})(HTTP_AUTHORIZATION_TYPE || {});
export var HTTP_RESPONSE_TYPE = /* @__PURE__ */ ((HTTP_RESPONSE_TYPE2) => {
  HTTP_RESPONSE_TYPE2["DIRECT"] = "direct";
  HTTP_RESPONSE_TYPE2["CALLBACK_URL"] = "callback_url";
  return HTTP_RESPONSE_TYPE2;
})(HTTP_RESPONSE_TYPE || {});
export var HTTP_CALLBACK_QUERY_PARAM = /* @__PURE__ */ ((HTTP_CALLBACK_QUERY_PARAM2) => {
  HTTP_CALLBACK_QUERY_PARAM2["CALLBACK_URL"] = "callbackURL";
  HTTP_CALLBACK_QUERY_PARAM2["CALLBACK_METHOD"] = "callbackMethod";
  HTTP_CALLBACK_QUERY_PARAM2["CALLBACK_CONTENT_TYPE"] = "callbackContentType";
  return HTTP_CALLBACK_QUERY_PARAM2;
})(HTTP_CALLBACK_QUERY_PARAM || {});
export var HTTP_RESPONSE_CODE_TYPE = /* @__PURE__ */ ((HTTP_RESPONSE_CODE_TYPE2) => {
  HTTP_RESPONSE_CODE_TYPE2["SERVER_ERROR"] = "server_error";
  HTTP_RESPONSE_CODE_TYPE2["REQUEST_ERROR"] = "request_error";
  HTTP_RESPONSE_CODE_TYPE2["REDIRECT"] = "redirect";
  HTTP_RESPONSE_CODE_TYPE2["SUCCESS"] = "success";
  HTTP_RESPONSE_CODE_TYPE2["INFORMATION"] = "information";
  return HTTP_RESPONSE_CODE_TYPE2;
})(HTTP_RESPONSE_CODE_TYPE || {});
export const HTTP_RESPONSE_CODE_TO_TYPE = {
  [200 /* OK */]: "success" /* SUCCESS */,
  [201 /* CREATED */]: "success" /* SUCCESS */,
  [202 /* ACCEPTED */]: "success" /* SUCCESS */,
  [400 /* REQUEST_ERROR */]: "request_error" /* REQUEST_ERROR */,
  [401 /* REQUEST_UNAUTHORIZED */]: "request_error" /* REQUEST_ERROR */,
  [402 /* PAYMENT_REQUIRED */]: "request_error" /* REQUEST_ERROR */,
  [403 /* REQUEST_DENIED */]: "request_error" /* REQUEST_ERROR */,
  [404 /* REQUEST_NOT_FOUND */]: "request_error" /* REQUEST_ERROR */,
  [408 /* REQUEST_TIMEOUT */]: "request_error" /* REQUEST_ERROR */,
  [409 /* REQUEST_CONFLICT */]: "request_error" /* REQUEST_ERROR */,
  [422 /* UNPROCESSABLE_ENTITY */]: "request_error" /* REQUEST_ERROR */,
  [429 /* REQUEST_TOO_MANY */]: "request_error" /* REQUEST_ERROR */,
  [500 /* SERVER_ERROR */]: "server_error" /* SERVER_ERROR */,
  [503 /* SERVER_UNAVAILABLE */]: "server_error" /* SERVER_ERROR */
};
